import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { Job } from '@/class/model/booking/Job'
import { WarehouseInfo } from '@/class/model/booking/WarehouseInfo'
import DateUtils from '@/utils/dateUtils'
import { Company } from '@/class/model/mdm/Company'
import { TruckingInfo } from '@/class/model/booking/TruckingInfo'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { getPortCodeByMapping } from '@/api/seaport'
import { getSpecificBasicData, operateBranchIsOptional } from '@/utils/basicDataCache'
import { TabBookingAbstract as TabBookingBaseAbstract } from '@/components/Cargo/Job/booking/tabs/tabBookingAbstract.js'
import { BackUpWarehouseInfo } from '@/class/model/booking/BackUpWarehouseInfo'
import { basicCacheKeys } from '@/utils/cacheConfig'
export class TabBookingAbstract extends TabBookingBaseAbstract {
  /**
   * @param {Object} view 视图
   */
  constructor(view) {
    super(view)
    this.view = view
    // this.tipCustomerRefNo = '指客户方对托运货运的自有编号，如PO NBR, ITEM NBR 等。'
    // this.tipIsAgentPrice = '如果本票货物使用海外代理同船公司的约价，在此处打钩'
    // this.tipBookingAgent = '特指UBI前去订舱的船公司或者同行'
    // this.tipWeightContract = '单位： 公斤'
    // this.tipCubageContract = '单位： 立方米'
    // this.tipQuantityActual = '单位： 公斤'
    // this.tipWeightActual = '单位： 公斤'
    // this.tipCountWeight = '单位： 吨'
    this.tipFinalDestination = "FINAL DESTINATION (FOR MERCHANT'S REFERENCE)"
    this.job = null
    this.isEditing = this.view.isEdit
    this.warehouseInfo = null
    this.visibleEditSeaEq = false
    this.visibleSeaEqButton = false
    this.enabledContainerLoadType = false
    this.customerContacts = []
    this.customerSpecialRequests = []
    this.visibleDesignationAgent = false
    this.checkCubageActuaOffsetCharge = false
    this.carrierIdIsDirty = false
    this.canChangeSalesOfJob = false
    this.vesselLine = '' // 卸货港航线
    this.IsSpecifiedSalesBusiness = false
    this.isJoinPortDestinationAgent = false // 目的港和目的港代理关联
    this.backUpWarehouseInfo = null
  }
  get context() {
    return this.view.context
  }
  set context(context) {
    this.view.context = context
  }
  get userList() {
    return this.view.context.userList
  }
  set userList(userList) {
    this.view.context.userList = userList
  }
  get office() {
    return this.view.context.office
  }
  set office(office) {
    this.view.context.office = office
  }
  get companyList() {
    return this.view.context.companyList
  }
  set companyList(companyList) {
    this.view.context.companyList = companyList
  }
  get seaPortList() {
    return this.view.context.seaPortList
  }
  set seaPortList(seaPortList) {
    this.view.context.seaPortList = seaPortList
  }
  get regionList() {
    return this.view.context.regionList
  }
  set regionList(regionList) {
    this.view.context.regionList = regionList
  }
  get config() {
    return this.view.config
  }
  set config(config) {
    this.view.config = config
  }
  get isJoinCarrierBookingAgent() {
    return this.view.isJoinCarrierBookingAgent
  }
  set isJoinCarrierBookingAgent(isJoinCarrierBookingAgent) {
    this.view.isJoinCarrierBookingAgent = isJoinCarrierBookingAgent
  }
  get warehouseNoeditable() {
    return this.view.warehouseNoeditable
  }
  set warehouseNoeditable(warehouseNoeditable) {
    this.view.warehouseNoeditable = warehouseNoeditable
  }
  get bookingTermEditable() {
    return this.view.bookingTermEditable
  }
  set bookingTermEditable(bookingTermEditable) {
    this.view.bookingTermEditable = bookingTermEditable
  }
  get job() {
    return this.view.form
  }
  set job(job) {
    this.view.form = job
  }
  /**
	 * 非委托单(操作分公司可修改,客服跟销售分公司,根据操作分公司刷新操作、操作部门、单证)
	 * 委托单(操作分公司不可修改,客服跟操作分公司,根据操作分公司刷新操作、操作部门、单证)
	 * HQ单(操作分公司可修改,客服跟操作分公司,根据操作分公司刷新操作、客服、操作部门、单证)
	 */
  isEntrustOrder(isRegionalCommission = false) {
    if (isRegionalCommission && operateBranchIsOptional()) {
      return false
    } else {
      const job = this.job
      const company = this.companyList.filter(p => p.cmpIdx === job.customerId)[0]
      if ((job.salesOffice === this.office.officeId && !job.trustFromJob && company && company.linkedBranchId === 0) ||
          (job.salesOffice === 1)) {
        return false // 非委托单
      }
      return true
    }
  }
  /**
	 * 销售部门(销售不为空时才能修改)
	 */
  isSalesDepartmentUpdate() {
    const job = this.job
    if (job && Number(job.salesDepartment) > 0 && Number(job.sales) > 0) {
      return true
    }
    return false
  }
  /**
	 * 起运港修改
	 */
  async loadingPortCodeChange(data) {
    const job = this.job
    job.loadingPortCode = data.value
    await this.portChange()
    // 主票起运港改变，小票的提单起运港也要改变
    if (job.lclSlaves && job.lclSlaves.length > 0) {
      const seaPorts = this.view.$refs.loadingPortCode.options
      const ports = seaPorts.filter(p => p.code === job.loadingPortCode)
      if (ports.length > 0) {
        const loadingPort = ports[0]
        for (const item of job.lclSlaves) {
          const slave = new SeaExportJob(item)
          const hdoc = slave.getCargoDocByType('HBL', true)
          const mdoc = slave.getCargoDocByType('MBL', true)
          if (hdoc) {
            hdoc.loadingPort = loadingPort.englishName
            hdoc.loadingPortCode = job.loadingPortCode
          }
          if (mdoc) {
            mdoc.loadingPort = loadingPort.englishName
            mdoc.loadingPortCode = job.loadingPortCode
          }
        }
      }
    }
  }
  /**
	 * //订舱单位选择了有船公司性质的，船公司跟订舱单位一样。
	 * //订舱单位置空或没船公司性质的，船公司置空。
	 * //检查是否有变化,有变化才触发。
	 */
  async bookingAgentChangeCl() {
    if (this.isJoinCarrierBookingAgent) return
    const job = this.job
    if (!job.carrierId) {
      const company = await Company.getCompanyById(job.bookingAgent)
      if (company && company.seaCmp) {
        job.carrierId = company.cmpIdx
      }
    }
  }
  /** 港口条款关联处理
	 *  起运港----->分单签单地点----->主单签单地点
	 *  分单运费条款 PP 分单付款地点-----起运港
	 *              CC 分单付款地点-----目的港
	 *
	 *              3r 分单付款地点-----目的港
	 *  主单运费条款 PP 主单付款地点-----起运港
	 *              CC 主单付款地点-----目的港
	 *              3r 主单付款地点-----无动作
	 * 订舱，主单运费条款、分单运费条款，如果CC的情况，主单、分单付款地点应该自动刷目的港；
	 */
  async portChange(flag = true) {
    const job = new SeaExportJob(this.job)
    const hdoc = await job.getCargoDocByType('HBL', true)
    const mdoc = await job.getCargoDocByType('MBL', true)
    const loadingPort = this.seaPortList.filter(p => p.code === job.loadingPortCode)[0]
    const destinationPort = this.seaPortList.filter(p => p.code === job.destinationPortCode)[0]
    // 分单运费条款
    if (job.paymentTermHBL === 'PP') {
      // PP 分单付款地点-----起运港
      hdoc.paymentPlaceBL = !loadingPort ? '' : loadingPort.englishName
    } else if (job.paymentTermHBL === 'CC' || job.paymentTermHBL === '3P') {
      // CC 分单付款地点-----目的港 3r 分单付款地点-----目的港
      hdoc.paymentPlaceBL = !destinationPort ? '' : destinationPort.englishName
    }
    // 主单运费条款
    if (job.paymentTermMBL === 'PP' || job.paymentTermMBL === '3P') {
      // PP 主单付款地点-----起运港
      mdoc.paymentPlaceBL = !loadingPort ? '' : loadingPort.englishName
    } else if (job.paymentTermMBL === 'CC') {
      // CC 主单付款地点-----目的港
      mdoc.paymentPlaceBL = !destinationPort ? '' : destinationPort.englishName
    }
    if (flag) {
      await this.changeVesselLine()
    }
    // 签发地点
    hdoc.signPlaceBL = this.getCity(loadingPort)
    mdoc.signPlaceBL = this.getCity(loadingPort)
    this.copyPortToCargo()
  }
  /**
	 * 订舱输入卸货港后,船名航次页签卸货港代码会根据参数自动选择港口五子码,五子码希望和EDI的港口一样
	 */
  refreshPortCode(port, carrierId) {
    const job = this.job
    if (carrierId) {
      if (!port || !carrierId) return
      const params = {
        sourceCode: port,
        carrierId: carrierId,
        officeId: this.view.$store.getters.currentOfficeId
      }
      getPortCodeByMapping(params).then(res => {
        job.portCode = res.data
      }).catch().finally()
    } else {
      if (this.seaPortList && this.seaPortList.length > 0) {
        for (const seaPort of this.seaPortList) {
          if (port === seaPort.code) {
            job.portCode = seaPort.code
            break
          }
        }
      }
    }
  }
  /**
	 * 显示卸货港航线
	 */
  checkVesselLine() {
    const job = this.job
    this.vesselLine = ''
    this.job.airLine = ''
    if (job.dischargingPortCode) {
      const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
      if (port) {
        const region = this.regionList.find(p => p.code === port.region)
        this.vesselLine = region ? (this.view.$store.getters.language === 'zh' ? region.name : region.nameEnglish) : ''
        this.job.airLine = this.vesselLine
      }
    }
  }

  /**
   * 修改卸货港航线
   */
  async changeVesselLine() {
    const job = this.job
    let updateVesselLine = true
    if (job.dischargingPortCode) {
      const port = this.seaPortList.find(p => p.code === job.dischargingPortCode)
      if (port) {
        const region = this.regionList.find(p => p.code === port.region)
        if (job.scNo) {
          let shippingContractList = []
          await JobUtils.queryContractNumber().then(contractNumbers => {
            shippingContractList = contractNumbers
          })
          const shippingContract = shippingContractList.find(item => item.contractNumber === job.scNo)
          const sCNumberSelectMethod = Number(await this.config.get('SCNumberSelectMethod')) !== 0
          if (region && shippingContract && shippingContract.applicableRoutes && shippingContract.applicableRoutes.length > 0) {
            let routeCodes = []
            if (typeof shippingContract.applicableRoutes === 'string') {
              routeCodes = shippingContract.applicableRoutes.split(',').map(s => s.trim()).filter(Boolean)
            } else if (Array.isArray(shippingContract.applicableRoutes)) {
              routeCodes = shippingContract.applicableRoutes
            }
            const routeCode = routeCodes.find(code => code === region.code)
            if (!routeCode && sCNumberSelectMethod) {
              const regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
              const codeToNameMap = {}
              regionList.forEach(item => {
                codeToNameMap[item.code] = this.view.$store.getters.language === 'zh' ? item.name : item.nameEnglish
              })
              const routeOptionsCn = routeCodes.map(code => codeToNameMap[code] || code)
              const message = this.view.$t('SeaExport.NumberApplicableToAirline', [routeOptionsCn.join(',')])
              await this.view.$confirm(this.view.$t('SeaExport.AirlineDifferent', [message]),
                this.view.$t('common.btn.confirm'), {
                  confirmButtonText: this.view.$t('common.btn.ok'),
                  cancelButtonText: this.view.$t('common.btn.cancel'),
                  dangerouslyUseHTMLString: true,
                  type: 'warning'
                }
              ).then(async() => {
              }).catch(() => {
                updateVesselLine = false
              })
            }
          }
          if (!region && sCNumberSelectMethod && shippingContract && shippingContract.applicableRoutes && shippingContract.applicableRoutes.length > 0) {
            let routeCodes = []
            if (typeof shippingContract.applicableRoutes === 'string') {
              routeCodes = shippingContract.applicableRoutes.split(',').map(s => s.trim()).filter(Boolean)
            } else if (Array.isArray(shippingContract.applicableRoutes)) {
              routeCodes = shippingContract.applicableRoutes
            }
            const regionList = await getSpecificBasicData(basicCacheKeys.basic_data_Region)
            const codeToNameMap = {}
            regionList.forEach(item => {
              codeToNameMap[item.code] = this.view.$store.getters.language === 'zh' ? item.name : item.nameEnglish
            })
            const routeOptionsCn = routeCodes.map(code => codeToNameMap[code] || code)
            const message = this.view.$t('SeaExport.NumberApplicableToAirline', [routeOptionsCn.join(',')])
            await this.view.$confirm(this.view.$t('SeaExport.AirlineDifferent', [message]),
              this.view.$t('common.btn.confirm'), {
                confirmButtonText: this.view.$t('common.btn.ok'),
                cancelButtonText: this.view.$t('common.btn.cancel'),
                dangerouslyUseHTMLString: true,
                type: 'warning'
              }
            ).then(async() => {
            }).catch(() => {
              updateVesselLine = false
            })
          }
        }
        if (updateVesselLine) {
          this.vesselLine = region ? (this.view.$store.getters.language === 'zh' ? region.name : region.nameEnglish) : ''
          this.job.airLine = this.vesselLine
        }
      }
    }
  }
  getCity(port) {
    let city = this.office.cityName
    if (!city) {
      city = port ? port.englishName : ''
    }
    return city
  }
  /**
	 * 复制港口信息到主单和分单
	 */
  copyPortToCargo() {
    const job = new SeaExportJob(this.job)
    if (!job.uuid) {
      const hbl = job.getCargoDocByType('HBL', true)
      const mdoc = job.getCargoDocByType('MBL', true)
      hbl.dispatchingPlace = mdoc.dispatchingPlace = job.dispatchingPlace
      hbl.loadingPort = mdoc.loadingPort = this.getSeaportName(job.loadingPortCode)
      hbl.loadingPortCode = mdoc.loadingPortCode = loadingPort
      hbl.dischargingPort = mdoc.dischargingPort = this.getSeaportName(job.dischargingPortCode)
      hbl.dischargingPortCode = mdoc.dischargingPortCode = job.dischargingPortCode
      hbl.destinationPort = mdoc.destinationPort = this.getSeaportName(job.destinationPortCode)
      hbl.destinationPortCode = mdoc.destinationPortCode = job.destinationPortCode
      hbl.destinationPlace = mdoc.destinationPlace = job.destinationPlace
      const loadingPort = this.seaPortList.filter(p => p.code === job.loadingPortCode)[0]
      hbl.signPlaceBL = this.getCity(loadingPort)
      mdoc.signPlaceBL = this.getCity(loadingPort)
    }
  }
  getSeaportName(code) {
    const port = this.seaPortList.filter(p => p.code === code)[0]
    if (port) {
      return port.englishName
    }
    return ''
  }
  /**
	 *  bug 1444,1532
	 */
  changeDefaultHBLPayment() {
    const job = this.job
    if (job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code) {
      job.freightTermHBL = 'CY-CY'
    } else if (job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code ||
      job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code ||
      job.containerLoadType === ContainerLoadType.BULK_CARGO_TYPE.code) {
      job.freightTermHBL = 'CFS-CFS'
    }
  }
  /**
	 * 海运订舱本地服务默认选择项
	 * 整箱默认选中：门点装箱/提货。
	 * 自拼，bc，拼箱默认选中：内装箱/仓储
	 */
  selectDefaultLocalService() {
    const job = this.job
    if (!job.uuid) {
      switch (job.containerLoadType) {
        case ContainerLoadType.FCL_CARGO_TYPE.code:
          job.landTransportation = true
          job.warehousing = !job.landTransportation
          job.selfDeliver = !job.landTransportation
          break
        default:
          job.warehousing = true
          job.landTransportation = !job.warehousing
          job.selfDeliver = !job.warehousing
          break
      }
    }
  }
  /**
	 * 默认创建仓库信息
	 */
  async getWarehouseInfo() {
    const job = this.job
    await new Job(job).getWarehouseInfo()
    if (job.warehouseCmp && job.warehouseCmp > 0) {
      if (!job.warehouseInfo || job.warehouseInfo.length === 0) {
        this.warehouseInfo = new WarehouseInfo().fillDefaultValue().getData()
      } else {
        this.warehouseInfo = job.warehouseInfo[0]
      }
      // console.log('this.warehouseInfo========1', this.warehouseInfo, this.warehouseInfo.warehouseCmp)
      const warehouseInfo = this.warehouseInfo
      // console.log('this.warehouseInfo========1.5', job.warehouseCmp, warehouseInfo.warehouseCmp)
      if (warehouseInfo && job.warehouseCmp !== warehouseInfo.warehouseCmp) {
        const fileCutoffDay = parseInt(await this.config.get('SEFileCutoffDetaultDay'))
        const ctrlEstArrivalDate = parseInt(await this.config.get('CtrlEstArrivalDate')) === 1
        if (fileCutoffDay > 0 && job.etd && ctrlEstArrivalDate) {
          warehouseInfo.arriveDate = DateUtils.getFourDaysAgoWithoutHoliday(job.etd, fileCutoffDay)
          warehouseInfo.arriveDate.setHours(16, 0)
        }
        // console.log('this.warehouseInfo========2', warehouseInfo.warehouseCmp, job.warehouseCmp)
        warehouseInfo.warehouseCmp = job.warehouseCmp
        warehouseInfo.jobUuid = job.uuid
        warehouseInfo.contactData = false
        const company = await Company.getCompanyById(job.warehouseCmp)
        if (company) {
          company.warehouseDetail = ''
          await new Company(company).getWarehouseDetail()
          await this.loadWarehouseDetailHandler(company)
        }
      }
    } else { // 如果手动清空仓储，则打断仓储与Job的关联关系
      if (job.warehouseInfo && job.warehouseInfo.length > 0) {
        for (const warehouseInfo of job.warehouseInfo) {
          warehouseInfo.deleted = true
        }
      }
    }
  }
  async loadWarehouseDetailHandler(company) {
    const warehouseInfo = this.warehouseInfo
    // 仓库地址
    // const company = await Company.getCompanyById(job.warehouseCmp)
    if (company) {
      const warehouseDetail = Company.defaultWarehouse(company)
      if (warehouseDetail) {
        if (warehouseDetail['warehouseAddress']) {
          warehouseInfo.warehouseAddress = warehouseDetail['warehouseAddress']
        } else {
          warehouseInfo.warehouseAddress = company.address
        }
        warehouseInfo.warehouseContact = warehouseDetail['warehouseContact']
        warehouseInfo.warehouseContactTel = warehouseDetail['warehouseContactTel']
        warehouseInfo.warehouseName = warehouseDetail['warehouseName']
        warehouseInfo.mapFile = warehouseDetail['mapFile']
        warehouseInfo.remarks = warehouseDetail['remarks']
        // console.log('this.warehouseInfo========3', warehouseInfo, warehouseInfo.mapFile, warehouseInfo.remarks)
        if (!warehouseInfo.warehouseContact && !warehouseInfo.warehouseContactTel) {
          await this.loadContactsFunc(company)
        }
      } else {
        // console.log('this.warehouseInfo========3.5', warehouseInfo.warehouseContact, warehouseInfo.warehouseContactTel)
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseName = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
        await this.loadContactsFunc(company)
        warehouseInfo.warehouseAddress = company.address
      }
    }
  }
  async loadContactsFunc(company) {
    const warehouseInfo = this.warehouseInfo
    // console.log('this.warehouseInfo========4', warehouseInfo.warehouseContact, warehouseInfo.warehouseContactTel)
    if (!warehouseInfo.warehouseContact && !warehouseInfo.warehouseContactTel) {
      warehouseInfo.contactData = true
      await new Company(company).getContacts()
      const contacts = company.contacts
      // console.log('this.warehouseInfo========5', company.cmpIdx, contacts)
      if (contacts && contacts.length > 0) {
        let contact = null
        for (const ct of contacts) {
          if (ct.defaultContact) {
            contact = ct
            break
          }
        }
        // console.log('this.warehouseInfo========6', contact)
        // if (!contact) contact = contacts[0]
        if (contact) {
          warehouseInfo.warehouseContact = contact['contactPerson']
          warehouseInfo.warehouseContactTel = contact['telephone']
        } else {
          warehouseInfo.warehouseContact = ''
          warehouseInfo.warehouseContactTel = ''
        }
        warehouseInfo.warehouseName = ''
      }
    }
  }
  /**
	 * 默认创建门点信息
	 */
  async getTruckingInfo() {
    const job = this.job
    if (job.carryingCmp && job.carryingCmp > 0) {
      await new Job(job).getTrucking()
      if (!job.trucking) {
        job.trucking = []
      }
      let truckingInfo = null
      if (job.trucking.length === 0) {
        truckingInfo = new TruckingInfo().fillDefaultValue().getData()
      } else {
        truckingInfo = job.trucking[0]
      }
      truckingInfo.carryingCmp = job.carryingCmp
      truckingInfo.jobUuid = job.uuid
      if (!truckingInfo.truckOrderNo) {
        truckingInfo.truckOrderNo = JobUtils.createTruckOrderNo(job)
      }
      const company = await Company.getCompanyById(job.carryingCmp)
      if (company) {
        // 联系人
        await new Company(company).getContacts()
        const contacts = company.contacts
        if (contacts && contacts.length > 0) {
          if (truckingInfo && (!truckingInfo.driver || !truckingInfo.driverTel)) {
            const contact = contacts[0]
            truckingInfo.driver = contact['contactPerson']
            truckingInfo.driverTel = contact['telephone']
          }
        }
      }
    }
  }
  warehouseNoeditableCl() {
    this.bookingTermEditable = this.view.isEdit
    this.warehouseNoeditable = this.view.isEdit
  }
  /**
	 * 刷新计费体积
	 */
  txtCubageActualFocusOutHandler(cubageActual) {
    const defaultCubage = parseInt(this.config.get('ExportChargeCubageMT'))
    if (cubageActual <= defaultCubage) {
      this.job.chargeCubage = defaultCubage
    } else {
      this.job.chargeCubage = cubageActual
    }
  }
  // 获取默认前置仓信息
  async getBackUpWarehouseInfo() {
    const job = this.job
    await new Job(job).getBackUpWarehouseInfo()
    if (job.backUpWarehouseCmp && job.backUpWarehouseCmp > 0) {
      if (!job.backUpWarehouseInfo || job.backUpWarehouseInfo.length === 0) {
        this.backUpWarehouseInfo = new BackUpWarehouseInfo().fillDefaultValue().getData()
      } else {
        this.backUpWarehouseInfo = job.backUpWarehouseInfo[0]
      }
      const backUpWarehouseInfo = job.backUpWarehouseInfo[0]
      if (backUpWarehouseInfo && job.backUpWarehouseCmp !== backUpWarehouseInfo.warehouseCmp) {
        const fileCutoffDay = parseInt(await this.config.get('SEFileCutoffDetaultDay'))
        const ctrlEstArrivalDate = parseInt(await this.config.get('CtrlEstArrivalDate')) === 1
        if (fileCutoffDay > 0 && job.etd && ctrlEstArrivalDate) {
          backUpWarehouseInfo.arriveDate = DateUtils.getFourDaysAgoWithoutHoliday(job.etd, fileCutoffDay)
          backUpWarehouseInfo.arriveDate.setHours(16, 0)
        }
        backUpWarehouseInfo.warehouseCmp = job.backUpWarehouseCmp
        backUpWarehouseInfo.jobUuid = job.uuid
        backUpWarehouseInfo.contactData = false
        const company = await Company.getCompanyById(job.backUpWarehouseCmp)
        if (company) {
          company.warehouseDetail = ''
          await new Company(company).getWarehouseDetail()
          await this.loadBackUpWarehouseDetailHandler(company)
        }
      }
    } else { // 如果手动清空仓储，则打断仓储与Job的关联关系
      if (job.backUpWarehouseInfo && job.backUpWarehouseInfo.length > 0) {
        for (const backUpWarehouseInfo of job.backUpWarehouseInfo) {
          backUpWarehouseInfo.deleted = true
        }
      }
    }
  }
  async loadBackUpWarehouseDetailHandler(company) {
    const backUpWarehouseInfo = this.backUpWarehouseInfo
    if (company) {
      const warehouseDetail = Company.defaultWarehouse(company)
      if (warehouseDetail) {
        if (warehouseDetail['warehouseAddress']) {
          backUpWarehouseInfo.warehouseAddress = warehouseDetail['warehouseAddress']
        } else {
          backUpWarehouseInfo.warehouseAddress = company.address
        }
        backUpWarehouseInfo.warehouseContact = warehouseDetail['warehouseContact']
        backUpWarehouseInfo.warehouseContactTel = warehouseDetail['warehouseContactTel']
        backUpWarehouseInfo.warehouseName = warehouseDetail['warehouseName']
        backUpWarehouseInfo.mapFile = warehouseDetail['mapFile']
        backUpWarehouseInfo.remarks = warehouseDetail['remarks']
        if (!backUpWarehouseInfo.warehouseContact && !backUpWarehouseInfo.warehouseContactTel) {
          await this.loadContactsOfBackUpWarehouseInfo(company)
        }
      } else {
        backUpWarehouseInfo.warehouseContact = ''
        backUpWarehouseInfo.warehouseContactTel = ''
        backUpWarehouseInfo.warehouseName = ''
        backUpWarehouseInfo.mapFile = ''
        backUpWarehouseInfo.remarks = ''
        await this.loadContactsOfBackUpWarehouseInfo(company)
        backUpWarehouseInfo.warehouseAddress = company.address
      }
    }
  }
  async loadContactsOfBackUpWarehouseInfo(company) {
    const backUpWarehouseInfo = this.backUpWarehouseInfo
    if (!backUpWarehouseInfo.warehouseContact && !backUpWarehouseInfo.warehouseContactTel) {
      backUpWarehouseInfo.contactData = true
      await new Company(company).getContacts()
      const contacts = company.contacts
      if (contacts && contacts.length > 0) {
        let contact = null
        for (const ct of contacts) {
          if (ct.defaultContact) {
            contact = ct
            break
          }
        }
        if (contact) {
          backUpWarehouseInfo.warehouseContact = contact['contactPerson']
          backUpWarehouseInfo.warehouseContactTel = contact['telephone']
        } else {
          backUpWarehouseInfo.warehouseContact = ''
          backUpWarehouseInfo.warehouseContactTel = ''
        }
        backUpWarehouseInfo.warehouseName = ''
      }
    }
  }
}
